import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";
// const FeeTyoe = "/api/business/feeType";
const FeeTyoe = "/api/business/mt-f-i/feeType";
const CheckDuplicateCpn = "/api/business/check-duplicate-company";
const DoctypeListCreate = "/api/business/doc-type-list";
const DoctypeList = "/api/business/doc-type-for-eform-list";
//danh sách
const getListEform = "/api/business/eform-list";
export default class FromElectronicService {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
  public getAllCompanies(params?: any, query?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/company-for-eform?page=${params.page}&size=${params.size}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getBusinessCpn(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/company-type")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public getTypeOfDispatch(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/doc/bcdt-doc-types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Thêm mới công văn http://localhost:10001/api/business/create-eform
  public createEform(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/create-eform", query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public DoctypeListCreate(queryForm?: Array<number>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(DoctypeListCreate + `?` + this.convertObjectParamToStrings.convertObjectParamToStrings(queryForm))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Search mức phí
  public getAllCollectionRates(queryForm?: Array<number>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/mt-f-i/search`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Chi tiết Tờ khai
  public getCollectionRateByIds(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/mt-f-i/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Thêm mới
  public getAddCollRates(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/mt-f-i`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // update
  public UpdateCollRates(id: number, query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/mt-f-i/${id}`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getListDetailFee(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/mt-f-s?fee_type_id=${query}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Chỉnh sửa
  public getEditDeclaration(query: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`api/business/declarat/rate/`, query)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // Xóa
  public getDelete(id: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`/api/business/mt-f-i/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public DoctypeList(queryForm?: Array<number>): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(DoctypeList + `?` + this.convertObjectParamToStrings.convertObjectParamToStrings(queryForm))
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public AllFeetype(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(FeeTyoe, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public CheckDuplicateCpn(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(CheckDuplicateCpn, querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Danh sách biểu mẫu
  public getListEform(querySearch?: any, params?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(getListEform + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(params), querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // chi tiết biểu mẫu
  public getDetail(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`/api/business/eform?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  //delete e-form
  public deleteElform(id?: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/delete-eform?id=${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // edit el-form
  public EditElform(queryForm?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`/api/business/edit-eform`, queryForm)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  // Loại phí lệ phí
  public getFeeType(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get("/api/business/receipt/fee_types")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
